import { inject, Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { ApiResponse } from '@interfaces/api/api.interface';
import { environment } from '../../../../environments/environment';
import { ProductServiceParamsInterface } from '@interfaces/products/product_service_params_interface';
import { ProductDetails } from '@interfaces/products/product_detail_interface';
import { GetSpecialProductsData } from '@interfaces/products/get_special_products_data';
import { LanguageService } from '@core/services/language/language.service';

@Injectable({
  providedIn: 'root',
})
export class ProductsService {
  private http = inject(HttpClient);
  private getProductsEnpoint = environment.endpoints.products;
  private getProductDetailsEnpoint = environment.endpoints.productDetails;
  private api = environment.API_URL;
  private locale = inject(LanguageService);

  public getProducts(params: ProductServiceParamsInterface): Observable<ApiResponse<GetSpecialProductsData>> {
    const localeParams: ProductServiceParamsInterface = {
      ...params,
      locale: this.locale.getCurrentLanguage().toUpperCase(),
    };
    let httpParams = new HttpParams();

    (Object.keys(localeParams) as (keyof ProductServiceParamsInterface)[]).forEach(key => {
      const value = localeParams[key];
      if (value !== undefined && value !== null && value !== '') {
        httpParams = httpParams.set(String(key), String(value));
      }
    });
    return this.http.get<ApiResponse<GetSpecialProductsData>>(`${this.api}/${this.getProductsEnpoint}`, {
      params: httpParams,
    });
  }

  public getProductDetail(sellerID: string, productID: string): Observable<ApiResponse<ProductDetails>> {
    let httpParams = new HttpParams();
    httpParams = httpParams.set('locale', this.locale.getCurrentLanguage().toUpperCase());
    return this.http.get<ApiResponse<ProductDetails>>(
      `${this.api}/${this.getProductDetailsEnpoint}/${sellerID}/products/${productID}`,
      {
        params: httpParams,
      }
    );
  }
}
